import { Listbox } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

export type OptionType = {
  value: string
  display: string
}

export type FilterByProps = {
  defaultFilter?: string
  options: OptionType[]
  onChange: (option: OptionType) => void
  value?: string
}
export function FilterBy({ defaultFilter, options, value, onChange }: FilterByProps) {
  const [option, setOption] = useState<string | null>(
    options.find((option) => option.value === defaultFilter)?.display ?? `All`,
  )
  const onOptionChange = (option) => {
    setOption(option.value)
    onChange(option)
  }

  useEffect(() => {
    if (value) {
      setOption(options.find((option) => option.value === value)?.display ?? `All`)
    }
  }, [value])
  return (
    <Listbox
      as="div"
      className="relative z-20 flex cursor-pointer items-center bg-surface"
      value={option}
      onChange={onOptionChange}
    >
      {({ open }) => (
        <>
          <span className="mr-2 text-ui-xs text-default">Filter by: </span>
          <Listbox.Button as="div" className="btn btn-sm btn-tertiary">
            <p className="text-ui-xs capitalize text-default">
              {options.find((o) => o.value === option)?.display || ``}
            </p>
            <span className="pointer-events-none">
              <ChevronDownIcon
                className={classNames(`h-4 w-4 fill-current stroke-current text-default`, {
                  [`rotate-180 transform`]: open,
                })}
              />
            </span>
          </Listbox.Button>
          <Listbox.Options
            modal={false}
            className="absolute right-0 top-9 z-50 mt-1 max-h-60 overflow-auto rounded-lg border border-default bg-surface-raised shadow-elevation-4 ring-0 focus:outline-none"
            onWheel={(evt) => evt.stopPropagation()}
          >
            {options?.map((option) => (
              <Listbox.Option
                key={option.value}
                value={option}
                className={classNames(
                  `cursor-pointer p-4 text-body-sm capitalize text-default hover:bg-(--menu-hover)`,
                  {
                    [`filter-option-all`]: option.display.includes(`All`),
                  },
                )}
              >
                {option.display}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  )
}
